import templateStr from 'text!./templates/language-select.html';
/**
 * Widget for displaying language dropdown
 *
 * @returns {Object}
 */
export default (function () {
    return {
        restrict: 'A',
        replace: true,
        template: templateStr,
        controller: ['$scope', 'LocaleService', function ($scope, LocaleService) {
            $scope.currentLocaleDisplayName = LocaleService.getLocaleDisplayName();
            $scope.localesDisplayNames = LocaleService.getLocalesDisplayNames();
            $scope.visible = $scope.localesDisplayNames && $scope.localesDisplayNames.length > 1;

            // METHODS
            $scope.changeLanguage = function (locale) {
                LocaleService.setLocaleByDisplayName(locale);
                $scope.currentLocaleDisplayName = locale;
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/l10n/directives/LanguageSelectDirective.js
// module id = 1046
// module chunks = 0